"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Grants_1 = require("./_Grants");
var _Owner_1 = require("./_Owner");
exports._AccessControlPolicy = {
    type: "structure",
    required: [],
    members: {
        Grants: {
            shape: _Grants_1._Grants,
            locationName: "AccessControlList"
        },
        Owner: {
            shape: _Owner_1._Owner
        }
    }
};
//# sourceMappingURL=_AccessControlPolicy.js.map